import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["en", "ar"], // Ensure languages are defined
    fallbackLng: "en",
    debug: true, // Enable debug mode to check if it's working
    detection: {
      order: ["localStorage", "cookie", "navigator"],
      caches: ["localStorage", "cookie"],
    },
    backend: {
      loadPath: "/locales/{{lng}}/translation.json", // Ensure files are here
    },
    interpolation: {
      escapeValue: false,
    },
  });
const changeLanguage = (lng) => {
  i18n.changeLanguage(lng).then(() => {
    document.documentElement.lang = lng;
    document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";

    // Apply font dynamically
    document.documentElement.style.fontFamily =
      lng === "ar"
        ? "'Tajawal', 'Cairo', 'Almarai', sans-serif"
        : "'Montserrat', sans-serif";
  });
};

export default i18n;
